import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useEditorStore } from '../../store/editorStore';
import { IoCloseOutline } from 'react-icons/io5';

interface WallConstructionInfoPanelProps {
  isVisible: boolean;
}

/**
 * Info panel displayed during wall construction mode.
 * Shows keyboard shortcuts and provides an exit button.
 */
const WallConstructionInfoPanel: React.FC<WallConstructionInfoPanelProps> = observer(({ isVisible }) => {
  const { t } = useTranslation();
  const editorStore = useEditorStore();

  if (!editorStore.wallConstructionMode) {
    return null;
  }

  const handleClose = () => {
    editorStore.setWallConstructionMode(false);
  };

  return (
    <div className={`absolute ${isVisible ? 'top-[88px]' : 'top-[71px]'} left-1/2 transform -translate-x-1/2 z-[9998] bg-toolbkg rounded-md border border-gray-300 shadow-sm px-3 py-1.5 flex items-center gap-2.5 max-w-2xl`}>
      <div className="flex items-center gap-2 text-xs text-gray-600 flex-wrap">
        <span>
          <kbd className="px-1.5 py-0.5 bg-white border border-gray-200 rounded text-[10px] font-mono leading-tight">{t('construction.click')}</kbd>
          <span>{t('construction.wallHintStart')}</span>
          <kbd className="px-1.5 py-0.5 bg-white border border-gray-200 rounded text-[10px] font-mono leading-tight">{t('construction.click')}</kbd>
          <span>{t('construction.wallHintMid')}</span>
          <kbd className="px-1.5 py-0.5 bg-white border border-gray-200 rounded text-[10px] font-mono leading-tight">{t('construction.enter')}</kbd>
          <span>{t('construction.wallHintFinish')}</span>
          <kbd className="px-1.5 py-0.5 bg-white border border-gray-200 rounded text-[10px] font-mono leading-tight">{t('construction.enter')}</kbd>
          <span>{t('construction.wallHintExact')}</span>
          <kbd className="px-1.5 py-0.5 bg-white border border-gray-200 rounded text-[10px] font-mono leading-tight">{t('construction.esc')}</kbd>
          <span>{t('construction.wallHintExit')}</span>
        </span>
      </div>
      <button
        onClick={handleClose}
        className="ml-auto flex items-center justify-center w-5 h-5 rounded hover:bg-gray-100 transition-colors flex-shrink-0"
        aria-label={t('construction.exitWallMode')}
        title={t('common.exit')}
      >
        <IoCloseOutline className="w-4 h-4 text-gray-500" />
      </button>
    </div>
  );
});

export default WallConstructionInfoPanel;
